export const MENU_MAX_WIDTH = 340;
export const MENU_MIN_WIDTH = 240;
// 80px allowance to prevent the helper text from breaking the layout of the menu arrows
const HELPER_TEXT_ALLOWANCE = 80;
export const MENU_HELPER_TEXT_MAX_WIDTH =
  MENU_MAX_WIDTH - HELPER_TEXT_ALLOWANCE;
